import React, { memo } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import { StoryblokAsset } from '../../interfaces/StoryblokAsset.interface';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import { Theme } from '../../interfaces/enums/Theme.enum';
import Heading, { HeadingTypes } from '../Heading/Heading';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';
import Container from '../Utils/Container/Container';
import Grid from '../Utils/Grid/Grid';
import Col from '../Utils/Col/Col';
import Image from '../Image/Image';
import SbImage from '../SbImage/SbImage';

interface PageHeroVariantOneBlokProps extends Blok {
  heading: string;
  body?: string;
  image: StoryblokAsset;
  cta: Blok[];
}

interface PageHeroVariantOneProps {
  blok: PageHeroVariantOneBlokProps;
}

const PageHeroVariantOne: React.FC<PageHeroVariantOneProps> = ({ blok }) => {
  const { heading, body = undefined, image, cta } = blok;

  return (
    <section {...storyblokEditable(blok)} className="py-16 lg:py-24">
      <Container>
        <Grid gapY="gap-y-12 lg:gap-y-0">
          <Col span={{ md: 10, lg: 6 }} start={{ md: 2, lg: 1 }}>
            <div className="h-full flex flex-col items-center justify-center gap-y-6 text-center lg:items-start lg:text-left">
              {heading && (
                <Heading text={heading} headingType={HeadingTypes.h1} />
              )}
              {body && <p className="text-text/body text-xl">{body}</p>}
              {cta?.map((cta_item: Blok) => (
                <div
                  className="w-full sm:w-fit sm:max-w-fit"
                  key={cta_item._uid}
                >
                  <StoryblokComponent blok={cta_item} />
                </div>
              ))}
            </div>
          </Col>
          <Col span={{ md: 10, lg: 5 }} start={{ md: 2, lg: 8 }}>
            <div className="h-full flex items-center justify-center">
              <div className="w-full aspect-video bg-text/body-tint">
                {image?.filename && (
                  <SbImage
                    asset={image}
                    options={{
                      width: 800,
                      height: 450,
                      sizes: {
                        base: 640,
                        sm: 768,
                        md: 1024,
                        lg: 1280,
                        xl: 1536,
                        xxl: 1920,
                      },
                      loading: 'eager',
                    }}
                  />
                )}
              </div>
            </div>
          </Col>
        </Grid>
      </Container>
    </section>
  );
};

export default memo(withBlokWrapper(PageHeroVariantOne, Theme.DARK));
